<div odxlayout="flex gap-none" class="flex-column w-100 container">
  <div odxLayout="flex" class="space-between">
    <h6 class="odx-title-6">{{ menuType | localizeFloorplanMenuType }}</h6>
    <button odxButton class="background-transparent flex-0" (click)="onClose()">
      <odx-icon name="close" size="medium"></odx-icon>
    </button>
  </div>

  <hr class="w-100" />

  @switch (menuType) {
    @case (FloorplanMenuType.MAIN_SETTINGS) {
      <app-floorplan-main-menu [activeFloorplan]="activeFloorplan"> </app-floorplan-main-menu>
    }
    @case (FloorplanMenuType.PRODUCT_SEARCH) {
      <app-fgds-product-search-menu> </app-fgds-product-search-menu>
    }
    @case (FloorplanMenuType.GROUP) {
      <app-floorplan-group-menu></app-floorplan-group-menu>
    }
    @case (FloorplanMenuType.ZONE) {
      <app-floorplan-zone-menu></app-floorplan-zone-menu>
    }
    @case (FloorplanMenuType.GAS_WARNING_CENTER) {
      <app-floorplan-gas-warning-center-menu></app-floorplan-gas-warning-center-menu>
    }
    @case (FloorplanMenuType.TRANSMITTER) {
      <app-floorplan-transmitter-menu></app-floorplan-transmitter-menu>
    }
    @case (FloorplanMenuType.FLAME_DETECTOR) {
      <app-floorplan-flame-detector-menu></app-floorplan-flame-detector-menu>
    }
    @case (FloorplanMenuType.SIGNAL_ELEMENT) {
      <app-floorplan-signal-menu></app-floorplan-signal-menu>
    }
    @case (FloorplanMenuType.PLASTIC_SIGN) {
      <app-floorplan-plastic-sign-menu></app-floorplan-plastic-sign-menu>
    }
    @case (FloorplanMenuType.ALARM_DEVICE) {
      <app-floorplan-alarm-device-menu></app-floorplan-alarm-device-menu>
    }
    @case (FloorplanMenuType.IMAGE) {
      <app-floorplan-image-menu></app-floorplan-image-menu>
    }
    @case (FloorplanMenuType.WIRING) {
      <app-floorplan-wiring-menu></app-floorplan-wiring-menu>
    }
    @case (FloorplanMenuType.AIR_PATH) {
      <app-floorplan-air-path-menu></app-floorplan-air-path-menu>
    }
    @case (FloorplanMenuType.ANNOTATION) {
      <app-floorplan-annotation-menu></app-floorplan-annotation-menu>
    }
    @case (FloorplanMenuType.DIMENSIONS) {
      <app-floorplan-dimensions-menu></app-floorplan-dimensions-menu>
    }
    @case (FloorplanMenuType.MONITORING_PRODUCT_SEARCH) {
      <app-monitoring-product-search-menu></app-monitoring-product-search-menu>
    }
    @case (FloorplanMenuType.MONITORING_ZONE) {
      <app-floorplan-monitoring-zone-menu></app-floorplan-monitoring-zone-menu>
    }
    @case (FloorplanMenuType.MONITORING_PATIENT_MONITOR) {
      <app-patient-monitor-menu></app-patient-monitor-menu>
    }
    @case (FloorplanMenuType.MONITORING_CENTRAL_STATION) {
      <app-central-station-menu></app-central-station-menu>
    }
    @case (FloorplanMenuType.MONITORING_TELEMETRY) {
      <app-telemetry-menu></app-telemetry-menu>
    }
    @case (FloorplanMenuType.MONITORING_KVM) {
      <app-kvm-menu></app-kvm-menu>
    }
    @case (FloorplanMenuType.MONITORING_DISPLAY) {
      <app-display-menu></app-display-menu>
    }
    @case (FloorplanMenuType.MONITORING_UTILITY) {
      <app-utility-menu></app-utility-menu>
    }
  }
</div>
